import { IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonLabel, IonLoading, IonMenuButton, IonPage, IonRow, IonTitle, IonToolbar } from '@ionic/react';
import { calendarOutline, calendarSharp, callOutline, callSharp, globeOutline, globeSharp } from 'ionicons/icons';
import React from 'react';
import { useSelector } from 'react-redux';
import { CheckInType } from '../features/pilgrimage/checkin';
import { selectCheckIns } from '../features/pilgrimage/pilgrimageSlice';
import { FetchStatus } from '../utils/fetch-status';

const Checkins: React.FC = () => {
  const checkins = useSelector(selectCheckIns),
    today = new Date(),
    remainingCheckins = (checkins.data ? [ ...checkins.data ] : [])
      .sort((a, b) => a.datetime < b.datetime ? -1 : 1)
      .filter(checkin => new Date(checkin.datetime) >= today);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>Check-Ins</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonContent class="ion-padding">
          { checkins.status === FetchStatus.Idle && <IonLabel color="light">Waiting...</IonLabel> }
          { checkins.status === FetchStatus.Pending && <IonLoading isOpen={true}></IonLoading> }
          { checkins.status === FetchStatus.Rejected && <IonLabel color="danger">{checkins.error ? `Error: ${checkins.error}` : `Error.`}</IonLabel> }
          { (checkins.data !== null && remainingCheckins.length > 0) && <IonGrid>
            <IonRow>
            {remainingCheckins
              .map(checkin => <IonCol size-md="6" key={checkin.datetime}>
                <IonCard>
                  <IonCardHeader>
                    <IonCardTitle class="ion-text-center">
                      {new Date(checkin.datetime).toLocaleDateString([], {
                          weekday: 'long', day: 'numeric', month: 'long'
                        })}
                        {" — "}
                        {new Date(checkin.datetime).toLocaleTimeString([], {
                          timeZoneName: 'short', hour: '2-digit', minute: '2-digit'
                        })}
                    </IonCardTitle>
                  </IonCardHeader>
                  <IonCardContent>
                    {checkin.type === CheckInType.Zoom && <React.Fragment>
                      <p className="centered-button">
                        <IonButton href={checkin.location} target="_system" size="large" fill="outline">
                          <IonIcon slot="start" src="/assets/svg/zoom.svg"></IonIcon>
                          <IonLabel>Zoom</IonLabel>
                        </IonButton>
                      </p>
                      <p className="centered-button">
                        Zoom Code
                      </p>
                      <p className="centered-button"><span className="zoom-code">{checkin.location.replace('https://us02web.zoom.us/j/', '')}</span></p>
                    </React.Fragment>}
                    {checkin.type === CheckInType.GoogleMeet && <p className="centered-button">
                      <IonButton href={checkin.location} target="_system" size="large" fill="outline">
                        <IonIcon slot="start" name="logo-google"></IonIcon>
                        <IonLabel>Google Meet</IonLabel>
                      </IonButton>
                    </p>}
                    {checkin.type === CheckInType.Skype && <p className="centered-button">
                      <IonButton href={checkin.location} target="_system" size="large" fill="outline">
                        <IonIcon slot="start" name="logo-skype"></IonIcon>
                        <IonLabel>Skype</IonLabel>
                      </IonButton>
                    </p>}
                    {checkin.type === CheckInType.Online && <p className="centered-button">
                      <IonButton href={checkin.location} target="_system" size="large" fill="outline">
                        <IonIcon slot="start" ios={globeOutline} md={globeSharp}></IonIcon>
                        <IonLabel>Join Online</IonLabel>
                      </IonButton>
                    </p>}
                    {checkin.type === CheckInType.Phone && <p className="centered-button">
                      <IonButton href={checkin.location?.startsWith('tel') ? checkin.location : `tel:${checkin.location}`} target="_system" size="large" fill="outline">
                        <IonIcon slot="start" ios={callOutline} md={callSharp}></IonIcon>
                        <IonLabel>Phone</IonLabel>
                      </IonButton>
                    </p>}
                    {checkin.type === CheckInType.InPerson && <p className="centered-button">
                      {checkin.location}
                    </p>}
                    {checkin.calendar && <p className="centered-button">
                      <IonButton href={checkin.calendar} target="_system" fill="clear">
                        <IonIcon slot="start" md={calendarSharp} ios={calendarOutline}></IonIcon>
                        <IonLabel>Add to Calendar</IonLabel>
                      </IonButton>
                    </p>}
                  </IonCardContent>
                </IonCard>
              </IonCol>
            )}
            </IonRow>
          </IonGrid>}
          {remainingCheckins.length === 0 && <IonCard>
            <IonCardContent>
            <p className="centered-button">There are no remaining check-ins scheduled for this pilgrimage.</p>
          </IonCardContent></IonCard>}
        </IonContent>
      </IonContent>
    </IonPage>
  );
};

export default Checkins;
